import React, { useContext } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import SubscribersOnly from '../../../../ActionBar/_partials/SubscribersOnly';
import { useScrollToDeviationComments } from '../../../../DeviationPage/_partials/Comments/useScrollToDeviationComments';
import Stats from '../../../../Stats';
import useOpenGroupStatModal from '../../../../Stats/GroupStat/useOpenGroupStatModal';

import s from './StatBlock.scss';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
}

/** Controls rendering stats (and SubscribersOnly on mobile) for most devpages */
export const StatBlock: React.FC<Props> = ({ deviation, className }) => {
  const isMobile = useContext(MobileContext);
  const { tier } = useSubscriptionTier(deviation);
  const withTierInfo = !!tier;
  const scrollToDeviationComments = useScrollToDeviationComments();
  const openGroupStatModal = useOpenGroupStatModal(deviation);

  if (isMobile && withTierInfo) {
    // the only difference between the following block and the one below
    // is designs need to have the subscribers only here on mobile
    // and the css control on how that and the stats and badges wrap
    return (
      <div className={classnames(s['root'], className)}>
        <SubscribersOnly deviation={deviation} />
        <Stats
          className={s['stats']}
          badgelistClassName={s['badges']}
          deviation={deviation}
          withViewCount={false}
          withSubscriberCount
          onCommentClick={scrollToDeviationComments}
        />
      </div>
    );
  }

  return (
    <Stats
      className={className}
      deviation={deviation}
      withViewCount={!withTierInfo}
      withGroupCount={!withTierInfo}
      withPrivateCollectionsCount={!withTierInfo}
      withSubscriberCount={withTierInfo}
      onCommentClick={scrollToDeviationComments}
      onGroupClick={openGroupStatModal}
    />
  );
};
StatBlock.displayName = 'StatBlock';

export default StatBlock;
